export default "__VITE_ASSET__e26ac658__"